var exports = {
  "M": "xa15a2ab7--aed0e5--page",
};

module.exports = exports;
